export default __webpack_public_path__ + "7a7f162b24294cb2f89be3a5cf1cd571.webp";